<template>
  <div class="content">
    <div class="md-layout">
      <div v-show="setup===0" class="md-layout-item md-medium-size-100 md-size-100">
        <edit-profile-form
          data-background-color="purple"
          :user="user"
          :name="name"
        >
        </edit-profile-form>
      </div>

      <div
        v-show="setup === 1"
        class="md-layout-item md-medium-size-100 md-size-100">
        <md-list-item>
          <div class="md-list-item-text">
            <h3>Adjust the pin to get the exact location</h3>
            <p>
              Drag & zoom to position the marker to the exact spot where your
              outlet is located
            </p>
          </div>

          <div class="md-layout-item text-right  md-list-action">
            <md-button class="md-raised md-primary" @click="loadMap">{{action}}</md-button>
          </div>
        </md-list-item>

        <div id="map"></div>
      </div>

      <div
        v-show="setup === 2"
        class="md-layout-item md-medium-size-100 md-size-100"> <user-card :user=user> </user-card>
      </div>
    </div>
  </div>
</template>

<script>
import { EditProfileForm, UserCard } from "@/pages";
import GoogleMapsLoader from "google-maps";
import firebase from "../Firebase";

export default {
    name : 'UserProfile',
  data() {
    return {
      setup: -1,
      lat: 0.0,
      lon: 0.0,
      user: {
          outletName: "",
          zip: "",
          canton: "",
          city: "",
          address: "",
          email: "",
          primaryContact: "",
          secondaryContact: "",
          startTime: "",
          endTime: "",
          categoriesPicker: [],
          days: [],
      },
      name: "Seller",
      action : "Next",
    };
  },
  components: {
    EditProfileForm,
    UserCard
  },
  created() {
    // check if the setup is complete
      firebase.auth().onAuthStateChanged(usr => {
          if (!usr){
              console.log(" #### ERROR!! The User is not loaded #####");
              window.location.href = "";
          }else{

              this.name = usr.displayName;
              let db = firebase.firestore().collection("sellers").doc(usr.uid);
              db.onSnapshot(doc => {
                  if (doc.exists) {
                      this.user = doc.data();
                      this.setup = this.user.setup;
                      if (this.setup===1){

                          GoogleMapsLoader.KEY = "AIzaSyD0x2bUiY9mmWl9iQVAS5Rp9mVn9hlxknk";
                          GoogleMapsLoader.load(google => {

                              if (this.user.lat && this.user.lon){
                                  this.initMap1(google);
                              }else{
                                  this.initMap(google);
                              }

                          });

                      }
                  } else {
                      db.set({
                          uid: this.user.uid,
                          email: this.user.email,
                          joined: new Date(),
                          setup: 0
                      }).then(value => {
                          this.setup = 0;
                      });
                  }

              });



          }
      });
  },
  methods: {
      geocodeAddress(geocoder, resultsMap) {
          let address = this.user.city;
          geocoder.geocode({'address': address}, (results, status) => {
              if (status === 'OK') {
                  resultsMap.setCenter(results[0].geometry.location);
                  let marker = new google.maps.Marker({
                      map: resultsMap,
                      position: results[0].geometry.location,
                      draggable:true,
                  });
                  marker.addListener('dragend', event => {
                      this.lat = marker.getPosition().lat();
                      this.lon = marker.getPosition().lng();
                  });
              } else {
                  alert('Geocode was not successful for the following reason: ' + status);
              }
          });
      },
    initMap(google) {

        let mapOptions = {
            zoom: 15,
            //center: myLatlng,
            //scrollwheel: true,
            styles: [
                {
                    featureType: "water",
                    stylers: [
                        { saturation: 43 },
                        { lightness: -11 },
                        { hue: "#0088ff" }
                    ]
                },
                {
                    featureType: "road",
                    elementType: "geometry.fill",
                    stylers: [
                        { hue: "#ff0000" },
                        { saturation: -100 },
                        { lightness: 99 }
                    ]
                },
                {
                    featureType: "road",
                    elementType: "geometry.stroke",
                    stylers: [{ color: "#808080" }, { lightness: 54 }]
                },
                {
                    featureType: "landscape.man_made",
                    elementType: "geometry.fill",
                    stylers: [{ color: "#ece2d9" }]
                },
                {
                    featureType: "poi.park",
                    elementType: "geometry.fill",
                    stylers: [{ color: "#ccdca1" }]
                },
                {
                    featureType: "road",
                    elementType: "labels.text.fill",
                    stylers: [{ color: "#767676" }]
                },
                {
                    featureType: "road",
                    elementType: "labels.text.stroke",
                    stylers: [{ color: "#ffffff" }]
                },
                { featureType: "poi", stylers: [{ visibility: "off" }] },
                {
                    featureType: "landscape.natural",
                    elementType: "geometry.fill",
                    stylers: [{ visibility: "on" }, { color: "#b8cb93" }]
                },
                { featureType: "poi.park", stylers: [{ visibility: "on" }] },
                {
                    featureType: "poi.sports_complex",
                    stylers: [{ visibility: "on" }]
                },
                { featureType: "poi.medical", stylers: [{ visibility: "on" }] },
                {
                    featureType: "poi.business",
                    stylers: [{ visibility: "simplified" }]
                }
            ]
        };
        this.geocodeAddress(new google.maps.Geocoder(), new google.maps.Map(document.getElementById("map"), mapOptions) )
    },
    initMap1(google){
        let myLatlng = new google.maps.LatLng(this.user.lat, this.user.lon);
        let mapOptions = {
            zoom: 15,
            center: myLatlng,
            //scrollwheel: true,
            styles: [
                {
                    featureType: "water",
                    stylers: [
                        { saturation: 43 },
                        { lightness: -11 },
                        { hue: "#0088ff" }
                    ]
                },
                {
                    featureType: "road",
                    elementType: "geometry.fill",
                    stylers: [
                        { hue: "#ff0000" },
                        { saturation: -100 },
                        { lightness: 99 }
                    ]
                },
                {
                    featureType: "road",
                    elementType: "geometry.stroke",
                    stylers: [{ color: "#808080" }, { lightness: 54 }]
                },
                {
                    featureType: "landscape.man_made",
                    elementType: "geometry.fill",
                    stylers: [{ color: "#ece2d9" }]
                },
                {
                    featureType: "poi.park",
                    elementType: "geometry.fill",
                    stylers: [{ color: "#ccdca1" }]
                },
                {
                    featureType: "road",
                    elementType: "labels.text.fill",
                    stylers: [{ color: "#767676" }]
                },
                {
                    featureType: "road",
                    elementType: "labels.text.stroke",
                    stylers: [{ color: "#ffffff" }]
                },
                { featureType: "poi", stylers: [{ visibility: "off" }] },
                {
                    featureType: "landscape.natural",
                    elementType: "geometry.fill",
                    stylers: [{ visibility: "on" }, { color: "#b8cb93" }]
                },
                { featureType: "poi.park", stylers: [{ visibility: "on" }] },
                {
                    featureType: "poi.sports_complex",
                    stylers: [{ visibility: "on" }]
                },
                { featureType: "poi.medical", stylers: [{ visibility: "on" }] },
                {
                    featureType: "poi.business",
                    stylers: [{ visibility: "simplified" }]
                }
            ]
        };
        let marker = new google.maps.Marker({
            map: new google.maps.Map(document.getElementById("map"), mapOptions) ,
            position: myLatlng,
            draggable:true,
        });

        marker.addListener('dragend', event => {
            this.lat = marker.getPosition().lat();
            this.lon = marker.getPosition().lng();
        });
        console.log(this.marker);
    },
    loadMap() {
        this.user.setup = 2;
        console.log(this.marker);
        this.user.lat = this.lat;
        this.user.lon = this.lon;
        console.log(this.user);
        firebase.firestore().collection("sellers").doc(this.user.uid)
            .update(this.user).then(result => {
                console.log(result);
            })

    }
  }
};
</script>
